import { useEffect, useState } from 'react';

/**
 * Whether a CSS media query currently matches.  For the cases where a
 * component must branch in JS rather than through a `css.create` rule, e.g.
 * rendering a different number of elements at a breakpoint.
 */
export default function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches
  );

  useEffect(() => {
    const list = window.matchMedia(query);
    setMatches(list.matches);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
